export const lang = {
    "loading": {
        "a1": "Cargando...",
        "a2": "No hay más",
        // new1211
        "a3": "Suscribiendose...",
        "a4": "Pago en proceso...",
        "a5": "Sumisión...",
        "a6": "Redención en curso...",
    },
    "tabbar": {
        "a1": "Inicio",
        "a2": "Posiciones",
        "a3": "Mercado",
        "a4": "Activos",
        "a5": "Mi Perfil"
    },
    "basic": {
        "a1": "Cambiar idioma",
        "a2": "Confirmar",
        "a3": "Cancelar"
    },
    "notifyPopup": {
        "a3": "Aceptar"
    },
    "gywm": {
        "a1": "Sobre nosotros",
        "a2": "Descripción de la empresa",
        "a3": "Política de privacidad",
        "a4": "Términos de servicio / uso"
    },
    "yssm": {
        "a1": "1. Objetivo y alcance",
        "a2": "Esta política tiene como fin proteger la privacidad y seguridad de los datos personales ({value}) de los usuarios (personas físicas o jurídicas) durante el uso de la plataforma.",
        "a3": "Aplica a todos los datos personales enviados o procesados a través de esta plataforma o sitios/sistemas relacionados — incluyendo apertura de cuenta, operaciones, soporte y administración interna.",
        "a4": "2. Tipos de datos recopilados y procesados",
        "a5": "La información que puede recopilarse incluye, entre otras:",
        "a6": "Datos de identificación:",
        "a7": "Nombre, DNI/pasaporte u otro documento oficial, fecha de nacimiento, CUIT/CUIL (si corresponde), etc.",
        "a8": "Datos de contacto:",
        "a9": "Domicilio, correo electrónico, número de teléfono, etc.",
        "a10": "Datos de cuenta y financieros:",
        "a11": "Información de cuentas bancarias o de pago, situación financiera, historial de transacciones, origen/destino de fondos, activos/pasivos, etc.",
        "a13": "Datos de uso y acceso:",
        "a14": "Dirección IP, datos del dispositivo, tipo de navegador, información de inicio de sesión, cookies/IDs de seguimiento, comportamiento de operación, preferencias y hábitos.",
        "a15": "Otra información proporcionada voluntariamente:",
        "a16": "Documentos de riesgo, formularios de compliance, archivos de verificación, registros de comunicación, etc.",
        "a17": "3. Finalidades y bases legales",
        "a18": "Los fines posibles del tratamiento incluyen:",
        "a19": "Brindar servicios de operación, administración de cuenta y soporte al usuario;",
        "a20": "Cumplir con leyes aplicables (incluyendo AML, verificación de identidad, normas impositivas y regulatorias);",
        "a21": "Prevención de fraude, lavado de dinero o uso indebido de la plataforma;",
        "a22": "Mejorar y mantener la seguridad y estabilidad del sistema/servicios;",
        "a23": "Con consentimiento del usuario, también podrá usarse para marketing, noticias/notificaciones e información sobre productos.",
        "a24": "Las bases legales incluyen consentimiento (consentimiento), necesidad contractual (prestación del servicio) y obligaciones legales/regulatorias (obligación legal).",
        "a25": "4. Procesamiento por terceros y transferencias internacionales",
        "a26": "Si los datos deben compartirse con terceros (procesadores de pago, servicios de verificación, proveedores de nube, etc.), se garantizará que solo se utilicen según los fines contractuales.",
        "a27": "Si deben transferirse fuera de Argentina, se emplearán medidas técnicas, organizacionales y contractuales adecuadas para asegurar un nivel adecuado de protección.",
        "a28": "5. Conservación de datos",
        "a29": "Los datos se conservan solo el tiempo necesario para cumplir los fines o los requisitos legales/regulatorios.",
        "a30": "Los datos de uso (logs, cookies, etc.) pueden utilizarse para análisis internos y seguridad, pero con plazos razonables.",
        "a31": "6. Derechos del usuario",
        "a32": "El usuario, como titular de los datos, posee los derechos establecidos por la Ley 25.326 (Protección de Datos Personales):",
        "a33": "Acceder a sus datos personales (solicitar acceso)",
        "a34": "Rectificar datos incorrectos o incompletos (rectificación)",
        "a35": "Solicitar la eliminación de datos (cuando no exista base legal para su tratamiento)",
        "a36": "Oponerse al tratamiento (oponerse al tratamiento) en los casos permitidos por ley",
        "a37": "Solicitar limitación del tratamiento o portabilidad (si aplica)",
        "a38": "La plataforma debe ofrecer canales claros (email, formularios, solicitudes escritas) para ejercer estos derechos.",
        "a39": "7. Medidas de seguridad",
        "a40": "La plataforma implementa medidas técnicas (encriptación, control de acceso, monitoreo, etc.) y organizativas para prevenir accesos no autorizados, filtraciones o destrucción de datos.",
        "a41": "Aun así, debido a los riesgos inherentes de Internet, no puede garantizarse seguridad absoluta. El usuario entiende y acepta este punto.",
        "a42": "8. Actualizaciones",
        "a43": "La política puede actualizarse periódicamente. Cambios importantes serán notificados por la plataforma o email.",
        "a44": "La versión actualizada entra en vigencia al publicarse. Continuar usando el servicio implica su aceptación.",
        "a45": "9. Ley aplicable y autoridad reguladora",
        "a46": "La política se rige por las leyes de Argentina.",
        "a47": "La autoridad competente es la Agencia de Acceso a la Información Pública (AAIP)."
    },
    "fwtk": {
        "a1": "1. Aceptación de los términos",
        "a2": "El usuario debe leer, entender y aceptar completamente estos términos antes de visitar o utilizar la plataforma, abrir una cuenta o realizar transacciones.",
        "a3": "Si el usuario no está de acuerdo con estos términos, no podrá usar los servicios de la plataforma.",
        "a4": "2. Derechos de la plataforma y modificación de los términos",
        "a5": "La plataforma se reserva el derecho de modificar, suspender o terminar los servicios, funciones, contenidos o acceso sin previo aviso.",
        "a6": "Cualquier cambio en estos términos será publicado y entrará en vigor desde su publicación.",
        "a7": "3. Uso legal y conducta prohibida",
        "a8": "El usuario se compromete a usar la plataforma conforme a la ley argentina, los principios de buena fe y el orden público. Se prohíben las siguientes conductas (incluyendo pero no limitándose a):",
        "a9": "Uso para fines ilegales o que perjudiquen los derechos de terceros;",
        "a10": "Interrumpir o dañar el funcionamiento normal de la plataforma, realizar solicitudes excesivas, enviar spam, usar scripts automáticos, bots o scraping de datos;",
        "a11": "Acceder sin autorización, intentar obtener o revelar cuentas o datos sensibles de otros usuarios/terceros;",
        "a12": "Subir o propagar virus, malware, spyware u otros códigos dañinos;",
        "a13": "Falsificar identidad, hacerse pasar por otro o utilizar información falsa para abrir una cuenta;",
        "a14": "Revender, transferir cuentas o compartir acceso sin autorización;",
        "a15": "Utilizar el servicio para publicidad, marketing o venta no autorizada de productos o servicios (a menos que la plataforma lo permita explícitamente);",
        "a16": "Cualquier otra conducta que viole estos términos, leyes o políticas de la plataforma.",
        "a17": "Si el usuario incumple estas reglas, la plataforma podrá suspender o terminar su cuenta, y se reserva el derecho de emprender acciones legales y reclamar daños y perjuicios.",
        "a18": "4. Descargo de responsabilidad y advertencia de riesgos",
        "a19": "La información proporcionada por la plataforma (como cotizaciones de valores, análisis de mercado, noticias, informes de investigación, etc.) es solo para referencia y no constituye asesoramiento de inversión, legal o fiscal.",
        "a20": "El usuario entiende y asume todos los riesgos derivados de las transacciones de valores o actividades financieras a través de esta plataforma.",
        "a21": "La plataforma no se hace responsable de cualquier pérdida directa, indirecta, incidental, especial o consecuente (incluyendo pero no limitado a pérdidas de ganancias, datos, fallas del sistema, etc.) derivada del uso (o no uso) de los servicios.",
        "a22": "5. Cumplimiento y Anti-lavado de dinero / Verificación de identidad (KYC/AML)",
        "a23": "Al abrir una cuenta o realizar transacciones, el usuario deberá proporcionar documentos de identificación (pasaporte, DNI, etc.), prueba de domicilio (factura de servicios, etc.), prueba de origen de fondos (extracto bancario, salario, etc.) y otros documentos/información requeridos para cumplir con las leyes anti-lavado de dinero.",
        "a24": "La plataforma se reserva el derecho de rechazar la apertura de cuenta o suspender transacciones por razones de cumplimiento sin necesidad de justificarlo.",
        "a25": "6. Integración con la política de privacidad y uso de datos",
        "a26": "El usuario acepta que la plataforma recopile, procese y almacene sus datos personales conforme a esta declaración de privacidad.",
        "a27": "La política de privacidad y estos términos de servicio constituyen el acuerdo completo entre las partes.",
        "a28": "7. Ley aplicable y resolución de disputas",
        "a29": "Estos términos están regidos por las leyes de Argentina. En caso de disputa, la misma se someterá a los tribunales ordinarios de Buenos Aires (o el lugar donde se encuentre la plataforma).",
        "a30": "8. Información de contacto",
        "a31": "Los usuarios pueden contactar a {value} para consultas sobre privacidad, protección de datos, términos, transacciones de cuentas, etc."
    },
    "addDebitCard": {
        "a1": "Agregar tarjeta bancaria",
        "a2": "Nombre",
        "a3": "Por favor, ingrese su nombre",
        "a4": "Nombre del banco",
        "a5": "Por favor, ingrese el nombre del banco",
        "a6": "Por favor ingrese {value}",
        "a7": "Tipo de cuenta",
        "a8": "Por favor, ingrese el tipo de cuenta",
        "a9": "Enviar",
        //
        "c1": "Vinculación exitosa",
        "c2": "Debe ser un número de 22 dígitos",
        "c3": "Dirección del banco",
        "c4": "Introduzca la dirección de su banco",
        "c5": "Número de cuenta bancaria",
        "c6": "Introduzca su número de cuenta bancaria",
        "c7": "Introduzca su código SWIFT",
        "c8": "Contraseña de retiro",
        "c9": "Ingrese su contraseña de retiro"
    },
    "asset": {
        "a1": "Activos totales",
        "a2": "Valor de mercado",
        "a3": "Saldo disponible",
        "a4": "Monto ocupado",
        "a5": "Ganancias totales",
        "a6": "Recargar",
        "a7": "Retirar",
        "a8": "Conversión de activos",
        "a9": "Historial de fondos",
        "a10": "Contraseña de fondos",
        "a11": "Solicitar préstamo",
        "a12": "Método de recarga",
        "a13": "Método de retiro",
        //
        "c1": "Aviso de verificación de identidad",
        "c2": "Verificar ahora",
        "c3": "Cancelar",
        "c4": "Para retirar fondos, debe completar la verificación de identidad. ¿Desea continuar?",
        "c5": "Ver verificación",
        "c6": "La verificación de identidad está en revisión. ¡Podrá retirar una vez aprobada!",
    },
    "assetConversion": {
        "a1": "Conversión de activos",
        "a2": "Historial de fondos",
        "a3": "De",
        "a4": "Saldo disponible",
        "a5": "Por favor, ingrese el monto de la solicitud",
        "a6": "Seleccione la moneda a convertir",
        "a7": "A",
        "a8": "Saldo actual:",
        "a9": "Monto recibido",
        "a10": "La conversión será según el monto realmente recibido",
        "a11": "Enviar ahora"
    },
    "dayTrading": {
        "a1": "Construcción de órdenes",
        "a2": "Enviar pedido",
        "a3": "Solicitado",
        "a4": "En operación",
        "a5": "Detalles de la operación",
        "a6": "Intervalo de participación:",
        "a7": "Por favor, ingrese el monto de su participación (mínimo {value})",
        "a8": "Enviar",
        "a9": "Número de orden",
        "a10": "Estado de la orden",
        "a11": "Pendiente de revisión",
        "a12": "Monto de la orden",
        "a13": "Rechazada",
        "a14": "Número de orden",
        "a15": "Estado de la orden",
        "a16": "Cerrada",
        "a17": "Tipo de operación",
        "a18": "Comprar al alza",
        "a19": "Hora de cierre",
        "a20": "Cantidad negociada",
        "a21": "Precio de compra",
        "a22": "Monto total de compra",
        "a23": "Comisión",
        "a24": "Precio de venta",
        "a25": "Monto total de venta",
        "a26": "Ganancia",
        "a27": "Confirmar",
        "a28": "Cancelar",
        "a29": "Descripción del producto",
        "a30": "Basado en el índice completo de acciones de la bolsa de Argentina, utiliza modelos de inteligencia artificial para una asignación de mercado diversificada, manteniendo al mismo tiempo un control de riesgo estable y un crecimiento continuo.",
        "a31": "Este fondo se centra en las 30 acciones estadounidenses de mayor capitalización y liquidez, utilizando una estrategia de igual ponderación para diversificar el riesgo. El fondo Broking AI Quant NGX sigue de cerca el índice completo de acciones NGX (ASI), por lo que es adecuado para configuraciones de cartera de inversión a largo plazo y estables.",
        "a32": "Inversión de cinco días, con un rendimiento diario esperado de 1,5% a 3%. Una inversión promedio de 4 millones de pesos puede generar una ganancia de 90 mil pesos. El fondo de crecimiento de mediana y pequeña capitalización estadounidense busca invertir en empresas medianas y pequeñas orientadas al crecimiento, ofreciendo retornos flexibles.",
        "a33": "Se centra en empresas estatales y compañías líderes de petróleo y gas, combinando el respaldo político con rendimientos estables de la industria energética.",
        "a34": "Rendimiento esperado",
        "a39": "Estrategia de inversión",
        "a40": "Ciclo de transacción",
        "a41": "Tasa total: {value}",
        "a42": "Monto de transacción",
        "a43": "Saldo disponible: {value}",
        "a44": "Límite mínimo {value}",
        "a45": "Saldo insuficiente",
        //
        "c1": "El monto de la transacción no puede estar vacío",
        // new1206
        "a35": "Sobre la base de una inversión de {value} pesos, se estima obtener un rendimiento diario de entre el 0,5% y el 1% en un plazo de 1 a 3 ruedas de negociación, con una ganancia diaria promedio de aproximadamente {value2} pesos.",
        "a36": "Sobre la base de una inversión de {value} pesos, se estima obtener un rendimiento diario de entre el 1% y el 1.5% en un plazo de 1 a 3 ruedas de negociación, con una ganancia diaria promedio de aproximadamente {value2} pesos.",
        "a37": "Inversión de {value} pesos por un período de 5 ruedas de negociación, con un rendimiento esperado de entre el 1.5% y el 2% por día, y una ganancia promedio diaria de {value2} pesos.",
        "a38": "Inversión de {value} pesos por un período de 7 ruedas de negociación, con un rendimiento esperado de entre el 3% y el 5% por día, y una ganancia promedio diaria de {value2} pesos.",
        "b1": "{value} cielo"
    },
    "etf": {
        "a1": "Recompra de productos",
        "a2": "Órdenes históricas",
        "a3": "Número de orden",
        "a4": "Producto",
        "a5": "Período (días)",
        "a6": "Hora de compra",
        "a7": "Hora de vencimiento",
        "a8": "Monto invertido",
        "a9": "Ganancia total esperada",
        "a10": "Días de tenencia",
        "a11": "Monto liberado",
        "a12": "Estado",
        "a13": "Recomprado",
        //
        "c1": "Pendiente de confirmación",
        "c2": "En transacción",
        "c3": "Contraseña de transacción",
    },
    "fundAccountManage": {
        "a1": "Gestión de cuenta financiera",
        "a2": "Agregar tarjeta bancaria",
        // newText
        "a3": "Gestión de tarjetas bancarias",
        "a4": "Vinculación de dirección",
        "a5": "Tipo de dirección",
        "a6": "Dirección",
        "a7": "Confirmación de eliminación",
        "a8": "Confirmar",
        "a9": "Cancelar",
        "a10": "¿Confirma eliminar esta tarjeta?",
        "a11": "La dirección ERC no puede estar vacía",
        "a12": "La dirección TRC no puede estar vacía",
        "a13": "Si desea cambiar una dirección vinculada, por favor contacte al soporte",
        "a14": "Dirección ERC20",
        "a15": "Dirección TRC20",
    },
    "fundingRecords": {
        "a1": "Historial de fondos",
        "a2": "Detalles de compra",
        "a3": "Depósito de fondos",
        "a4": "Retiro",
        "a5": "Conversión",
        "a6": "Monto recibido",
        "a7": "Monto solicitado",
        "a8": "Monto recibido",
        "a9": "Monto",
        "a10": "Hora",
        // newText
        "a11": "Ingresos",
        "a12": "Gastos",
        "a13": "Monto de recarga",
        "a14": "Incompleto",
        "a15": "Completado",
        "a16": "Cancelado",
        "a17": "Pendiente de revisión",
        "a18": "Acreditado",
        "a19": "Revisión no aprobada",
        "a20": "Reembolso de retiro"
    },
    "fundPassword": {
        "a1": "Contraseña de fondos",
        "a2": "Contraseña original",
        "a3": "Por favor ingrese la contraseña original",
        "a4": "Nueva contraseña",
        "a5": "Por favor ingrese la nueva contraseña",
        "a6": "Confirmar contraseña",
        "a7": "Por favor ingrese la contraseña confirmada",
        "a8": "Enviar ahora",
        // newText
        "a9": "Ingrese una contraseña de 6 dígitos",
        "a10": "Debe ser un número de 6 dígitos",
        "a11": "Contraseña",
        "a12": "Ingrese nuevamente la contraseña",
        "a13": "Las dos contraseñas no coinciden"
    },
    "index": {
        "a1": "Órdenes grandes",
        "a2": "Operación intradía",
        "a3": "Verificación de identidad",
        "a4": "Soporte en línea",
        "a5": "Índice global",
        "a6": "Más",
        "a7": "Acciones populares",
        "a8": "Personalizado",
        "a9": "Acciones de Argentina",
        "a10": "Acciones de EE.UU.",
        "a11": "Acciones/Código",
        "a12": "Último precio ({value})",
        "a13": "Cambio porcentual",
        // newText
        "a14": "Sistema de Trading Inteligente",
        "a15": "Basado en algoritmos de Deep Learning, analizando datos del mercado de los últimos 10 años.",
        "a16": "Rápido. Seguro. Fluido. El comercio en bloque redefinido.",
        "a17": "Descuento mayorista",
        "a18": "Noticias destacadas",
        "a19": "Sobre nosotros",
        "a20": "Preguntas frecuentes",
        "a21": "Sin datos por el momento",
        "a22": "Complete la verificación KYC y reciba",
        "a23": "Verificación de identidad",
        "a24": "Felicidades, su KYC fue aprobado. Se acreditó un bono de prueba en su cuenta.",
        "a25": "Comenzar a invertir",
        "a26": "Inversión automática con IA",
        "a27": "Ver ganancias",
        "a28": "Último precio",
        "a29": "Posición abierta",
        "a30": "Posición cerrada",
        "a31": "Fondos disponibles"
    },
    "ipo": {
        "a1": "Suscripción a acciones",
        "a2": "Ya suscrito",
        "a3": "En transacción",
        "a4": "Detalles de la transacción",
        "a5": "Suscripción automática",
        "a6": "No ganó la lotería",
        "a7": "Cantidad suscrita",
        "a8": "Hora de la lotería",
        "a9": "Cantidad ganada",
        "a10": "Ganancia estimada",
        "a11": "Monto pendiente",
        "a12": "Monto pagado",
        "a13": "Precio de emisión",
        "a14": "Precio del mercado",
        "a15": "Cerrada",
        // newText
        "a16": "Pendiente de adjudicación",
        "a17": "Adjudicado",
        "a18": "Rechazado",
        "a19": "Contraseña de transacción",
        "a20": "Detalles del Producto",
        "a21": "Cantidad Emitida",
        "a22": "Precio de Emisión",
        "a23": "Código de Acción",
        "a24": "Tipo de Cambio",
        "a25": "Fecha límite",
        "a26": "Suscribirse Ahora",
        "a27": "Número de Pedido",
        "a28": "Fecha límite",
        "a29": "Pagar ahora",
        "a30": "Precio Ganador",
        "a31": "Acciones Ganadoras",
        "a32": "Precio Total Ganador",
        "a33": "Ganancia Total",
        "a34": "Fecha de lanzamiento",
        "a35": "Fecha de Publicación",
        "a36": "Motivo de Rechazo",
        ////
        "a37": "Pendiente de Revisión",
        "a38": "Pendiente de Pago",
        "a39": "En Espera de Cotización",
        "a40": "Posición Cerrada",
        "a41": "Rechazado",
        "a42": "Suscrito",
        "a43": "El plazo ha sido cerrado.",
        "a44": "redención",
    },
    "login": {
        "a1": "Por favor ingrese su número de teléfono",
        "a2": "Por favor ingrese su contraseña",
        "a3": "Soporte en línea",
        "a4": "¿Olvidó su contraseña?",
        "a5": "Inicio de sesión seguro",
        "a6": "¿No tiene cuenta?",
        "a7": "Regístrese aquí",
        // newText
        "a8": "Iniciar sesión",
        "a9": "Bienvenido, por favor inicie sesión en su cuenta",
        "a10": "Formato de número telefónico incorrecto",
        "a11": "Inicio de sesión exitoso",
    },
    "register": {
        "a1": "Por favor ingrese la contraseña nuevamente",
        "a2": "Código de invitación (obligatorio)",
        "a3": "¿Ya tiene una cuenta?",
        "a4": "Iniciar sesión aquí",
        "a5": "Registro seguro",
        // newText
        "a6": "Registrarse",
        "a7": "Crear nueva cuenta",
        "a8": "Ingrese su número telefónico",
        "a9": "Formato incorrecto",
        "a10": "Ingrese una contraseña",
        "a11": "Mínimo 6 caracteres con combinación de letras y números",
        "a12": "Confirme la contraseña",
        "a13": "Las contraseñas no coinciden",
        "a14": "Ingrese el código de invitación",
        "a15": "Por favor, introduzca su documento de identidad",
        "a16": "Por favor, acepte primero el acuerdo.",
        "a17": "aceptar",
        "a18": "Acuerdo de registro",
        "a19": "Instrucciones de registro",
        "a20": "aceptar",

        "a21": "Información de la cuenta",

        "a22": "Información del usuario",

        "a23": "Nombre",

        "a24": "Ingrese su nombre.",

        "a25": "Seleccione su nacionalidad",

        "a26": "Anverso",

        "a27": "Seleccione desde su dispositivo",

        "a28": "Suba una foto del anverso de su documento de identidad.",

        "a29": "Suba una foto del reverso de su documento de identidad.",

        "a30": "Reverso",

        "a31": "Correo electrónico",

        "a32": "Ingrese su dirección de correo electrónico.",

        "a33": "Ingrese una dirección de correo electrónico válida.",

        "a34": "Dirección de residencia",

        "a35": "Ingrese su dirección de residencia.",

        "a36": "Ingresos anuales",
        "a37": "Seleccione sus ingresos anuales",

        "a38": "Patrimonio neto",
        "a39": "Seleccione el patrimonio neto",

        "a40": "Experiencia en inversiones",

        "a41": "Seleccione la experiencia en inversiones",

        "a42": "Tolerancia al riesgo",

        "a43": "Seleccione la tolerancia al riesgo",

        "a44": "No puede superar los 5 MB",

        "a45": "Subiendo...",

        "a46": "0 - 50.000",

        "a47": "50.000 - 100.000",

        "a48": "100.000 - 200.000",

        "a49": "200.000 - 500.000",

        "a50": "Más de 500.000",

        "a51": "Experimentado",

        "a52": "Sin experiencia",

        "a53": "Moderado",

        "a54": "Agresivo"
    },
    "mail": {
        "a1": "notificar",
        "a2": "Eliminar",
        // newText
        "a3": "Anuncios del sistema",
        "a4": "Notificaciones de órdenes",
        "a5": "Número de orden",
        "a6": "Resultado de revisión",
        "a7": "Notificación de bono de prueba",
        "a8": "Mensaje privado",
        "a9": "Moneda",
        "a10": "Precio de mercado",
        "a11": "Precio de compra",
        "a12": "Fecha de vencimiento",
        "a13": "aprobar"
    },
    "market": {
        "a1": "Por favor ingrese el nombre de la acción",
        "a2": "Buscar",
        "a3": "Personalizado",
        "a4": "Acciones de Argentina",
        "a5": "Acciones de EE.UU.",
        "a6": "Información",
        "a7": "Acciones/Código",
        "a8": "Último precio",
        "a9": "Cambio porcentual",
        // newText
        "a10": "Último precio",
        "a11": "Ver detalles",
        "a12": "Positivo",
        "a13": "Negativo",
        "a14": "Neutral",
        "a15": "Acciones de nacionalidad",
        "a16": "Fondos",
        "a17": "Futuros",
    },
    "marketDetail": {
        "a1": "Mercado",
        "a2": "Apertura de hoy",
        "a3": "Cierre de ayer",
        "a4": "Máximo",
        "a5": "Mínimo",
        "a6": "Precio de compra",
        "a7": "Precio total de compra",
        "a8": "Fondos disponibles",
        "a9": "Fondos totales",
        "a10": "Multiplicador de apalancamiento",
        "a11": "Cantidad a comprar",
        "a12": "Por favor ingrese la cantidad de compra",
        "a13": "Precio de toma de ganancias",
        "a14": "Por favor ingrese el precio de toma de ganancias",
        "a15": "Precio de stop loss",
        "a16": "Por favor ingrese el precio de stop loss",
        "a17": "Orden de compra",
        "a18": "Hora:",
        "a19": "Apertura:",
        "a20": "Cierre:",
        "a21": "Mínimo:",
        "a22": "Máximo:",
        // newText
        "a23": "Precio actual",
        "a24": "¿Activar take profit?",
        "a25": "¿Activar stop loss?",
        "a26": "Con su saldo disponible, puede comprar hasta",
        "a27": "acciones",
        "a28": "Ingrese la cantidad a comprar",
        "a29": "Ingrese el precio de stop loss",
        "a30": "El stop loss no puede ser mayor al precio actual",
        "a31": "Ingrese el precio de take profit",
        "a32": "El take profit no puede ser menor al precio actual",
        "a33": "Orden de compra",
        "a34": "Orden de venta",
        "a35": "Posición",
        "a36": "Precio promedio",
        "a37": "Acciones",
        "a38": "Límite",
        "a39": "Mercado",
        "a40": "Stop",
        "a41": "Vigencia",
        "a42": "Total estimado",
        "a43": "Cantidad a vender",
        "a44": "Orden de venta",
        "a45": "Precio límite",
        "a46": "Precio de mercado",
        "a47": "Precio de stop",
        "a48": "Vender"
    },
    "mine": {
        "a1": "Verificado",
        "a2": "Fondos disponibles",
        "a3": "Fondos disponibles",
        "a4": "Verificación de identidad",
        "a5": "Modificar contraseña de inicio de sesión",
        "a6": "Gestión financiera",
        "a7": "Soporte en línea",
        "a8": "Cambiar idioma",
        "a9": "Cerrar sesión",
        // newText
        "a10": "En revisión",
        "a11": "No aprobado",
        "a12": "No verificado",
        "a13": "Zona antifraude",
        "a14": "Información reglamentaria",
        "a15": "Divulgación de riesgos"
    },
    "newsDetail": {
        "a1": "Noticias"
    },
    "otc": {
        "a1": "Enviar pedido",
        "a2": "Pendiente de revisión",
        "a3": "Detalles de la operación",
        "a4": "Rechazada",
        "a5": "Precio del mercado",
        "a6": "Precio con descuento",
        "a7": "Ganancia por acción",
        "a8": "Cantidad mínima de compra",
        "a9": "Por favor ingrese la cantidad de compra",
        "a10": "Monto total de compra",
        "a11": "Fondos disponibles",
        "a12": "Confirmar",
        "a13": "Pendiente de revisión",
        "a14": "Hora de compra",
        "a15": "Cantidad negociada",
        "a16": "Precio de mercado",
        "a17": "Precio con descuento",
        "a18": "Monto total de compra",
        "a19": "Cerrada",
        "a20": "Rechazada",
        // newText
        "a21": "Descuento mayorista",
        "a22": "Suscripción del producto",
        "a23": "Asignado",
        "a24": "Detalles de la transacción",
        "a25": "Rechazado",
        "a26": "Precio de suscripción",
        "a27": "Precio actual",
        "a28": "Prima",
        "a29": "Fecha de publicación",
        "a30": "Fecha límite",
        "a31": "Suscrito",
        "a32": "Suscribirse ahora",
        "a33": "Pendiente de pago",
        "a34": "Número de orden",
        "a35": "Precio de suscripción",
        "a36": "Cantidad asignada",
        "a37": "Precio total",
        "a38": "Pagado",
        "a39": "Pendiente de pago",
        "a40": "Ganancia estimada",
        "a41": "Hora de suscripción",
        "a42": "Pagar ahora",
        "a43": "En posición",
        "a44": "Hora de inicio",
        "a45": "Hora de vencimiento",
        "a46": "Redimir",
        "a47": "Motivo del rechazo",
        "a48": "Confirmación de suscripción",
        "a49": "Confirmar",
        "a50": "Cancelar",
        "a51": "¡Suscribirse ahora puede generar más ganancias! ¿Desea continuar?",
        "a52": "Confirmación de pago",
        "a53": "¡Pagar ahora puede generar más ganancias! ¿Desea continuar?",
        "a54": "Confirmación de redención",
        "a55": "¿Confirma redimir ahora?",
        "a56": "Confirmación de venta",
        "a57": "Mantener la posición puede generar más beneficios. ¿Desea vender ahora?",
        // new1206
        "c1": "Suscripción exitosa",
        "c2": "Fecha límite de pago"
    },
    "positionDetails": {
        "a1": "Detalles de la inversión",
        "a2": "Cerrada",
        "a3": "Número de orden",
        "a4": "Precio de venta",
        "a5": "Hora de venta",
        "a6": "Hora de compra",
        "a7": "Tipo de operación",
        "a8": "Comprar al alza",
        "a9": "Cantidad cerrada",
        "a10": "Precio de compra",
        "a11": "Monto del contrato",
        "a12": "Comisión",
        "a13": "Comisión por cierre",
        "a14": "Precio actual",
        "a15": "Ganancia o pérdida real",
        "a16": "Rentabilidad",
        "a17": "Multiplicador de apalancamiento"
    },
    "realNameAuthentication": {
        "a1": "Verificación de identidad",
        "a2": "Aprobada",
        "a3": "Verificación de DNI",
        "a4": "Subir anverso",
        "a5": "Subir reverso",
        "a6": "Nombre completo",
        "a7": "Por favor ingrese su nombre completo",
        "a8": "Número de DNI",
        "a9": "Por favor ingrese el número de documento (8 dígitos)",
        "a10": "Enviar",
        // newText
        "a11": "Verificado",
        "a12": "En revisión",
        "a13": "Revisión no aprobada, por favor vuelva a enviar",
        "a14": "Teléfono",
        "a15": "Ingrese teléfono",
        "a16": "Correo electrónico",
        "a17": "Ingrese correo (opcional)",
        "a18": "Suba su documento de identidad",
        "a19": "Ingrese su nombre",
        "a20": "Ingrese su número de documento",
        "a21": "Ingrese teléfono",
        "a22": "Formato de correo inválido",
        "a23": "El DNI debe tener 11 dígitos",
        "a24": "El teléfono debe tener 10 dígitos",
        // newText2
        "c1": "Aviso",
        "c2": "Confirmar",
        "c3": "¡Enviado con éxito! Espere la revisión.",
        // new1208
        "c4": "Motivo de rechazo"
    },
    "topUp": {
        "a1": "Recargar",
        "a2": "Copiar",
        // newText
        "a3": "Monto de recarga",
        "a4": "Ingrese el monto",
        "a5": "Mínimo",
        "a6": "Monto a pagar",
        "a7": "Comisión",
        "a8": "Monto final",
        "a9": "Si necesita otros métodos de pago, contacte soporte",
        "a10": "Contactar soporte",
        "a11": "Notificación",
        "a12": "Contactar soporte",
        "a13": "Cancelar",
        "a14": "Las transferencias están prohibidas actualmente. Por favor, complete su transacción entre las 9:00 a. m. y las 10:00 p. m. Si tiene alguna pregunta, comuníquese con atención al cliente o recargue su cuenta con moneda virtual.",
        "a15": "El monto mínimo de recarga es",
        "a16": "Ingrese el monto de recarga",
        "a17": "Cargando página de pago...",
        "a18": "Recargar",
        "a19": "Si necesita otros métodos de pago, contacte soporte",
        "a20": "Nota: Este canal solo admite recargas con la red { value } y un mínimo de { value2 }",
        "a22": "Copiado con éxito",
    },
    "transaction": {
        "a1": "Acciones de Argentina",
        "a2": "Acciones de EE.UU.",
        "a3": "Por favor ingrese las palabras clave de búsqueda",
        "a4": "Buscar",
        "a5": "Asignación",
        "a6": "Posiciones de ETF",
        "a7": "En proceso",
        "a8": "Completado",
        "a9": "Valor de mercado {value}",
        "a10": "Fondos disponibles {value}",
        "a11": "Ganancia o pérdida {value}",
        "a12": "No ganó la lotería",
        "a13": "Cerrada",
        "a14": "Ganancia estimada",
        "a15": "Precio de suscripción {value}",
        "a16": "Cantidad suscrita",
        "a17": "Fecha de asignación",
        "a18": "Ganada la lotería",
        "a19": "Ya pagado {value}",
        "a20": "Pendiente de pago {value}",
        "a21": "Nombre de la acción",
        "a22": "Precio actual {value}",
        "a23": "precio medio {value}",
        "a24": "Tenencia",
        "a25": "Valor de mercado",
        "a26": "Ganancia o pérdida",
        "a27": "Posición abierta",
        "a28": "Tasa de retorno",
        "a29": "Hora de compra",
        "a30": "Hora de vencimiento",
        "a31": "Nombre del fondo",
        "a32": "Monto invertido",
        "a33": "Ganancia diaria",
        "a34": "Rentabilidad diaria",
        "a35": "Ganancia total",
        "a36": "Rentabilidad total",
        "a37": "Ciclo de transacciones",
        "a38": "Nombre de la acción",
        "a39": "Precio de venta {value}",
        "a40": "Cantidad cerrada",
        "a41": "Ganancia o pérdida",
        "a42": "Ganancia o pérdida",
        "a43": "Cerrada",
        // newText
        "a44": "Trading con IA",
        "a45": "Descuento mayorista",
        "a46": "Acciones",
        "a47": "En posición",
        "a48": "Número de orden",
        "a49": "Precio de suscripción",
        "a50": "Acciones asignadas",
        "a51": "Precio total",
        "a52": "Pagado",
        "a53": "Pendiente de pago",
        "a54": "Ganancia estimada",
        "a55": "Hora de inicio",
        "a56": "Hora de vencimiento",
        "a57": "Redimir",
        "a58": "Ganancia",
        "a59": "Vender",
        "a60": "En transacción",
        "a61": "Ciclo de trading",
        "a62": "días",
        "a63": "Ganancia estimada",
        "a64": "Hora de vencimiento",
        "a65": "Hora de suscripción",
        "a66": "Confirmación de redención",
        "a67": "Confirmar",
        "a68": "Cancelar",
        "a69": "¿Confirma redimir ahora?",
        "a70": "Confirmación de venta",
        "a71": "¿Confirma vender ahora?",
        // new1206
        "d1": "Cerrar posición",
        "d2": "Toma de ganancias",
        "d3": "Detener pérdidas",
        "d4": "Abrir órdenes de compra",
        "d5": "Abrir órdenes de venta",
        "d6": "Cantidad",
        "d7": "Órdenes pendientes",
        "d8": "Cancelar",
        "d9": "Cancelar confirmación",
        "d10": "¿Está seguro de que desea cancelar esta transacción?",
        "d11": "Precio",
        "d12": "Su cantidad máxima vendible es {valor}",
    },
    "updateLoginPassword": {
        "a1": "Modificar contraseña de inicio de sesión",
        "a2": "Contraseña original",
        "a3": "Por favor ingrese la contraseña original",
        "a4": "Nueva contraseña",
        "a5": "Por favor ingrese la nueva contraseña",
        "a6": "Confirmar contraseña",
        "a7": "Por favor ingrese la contraseña confirmada",
        "a8": "Enviar ahora",
        // newText
        "a9": "Al menos 6 caracteres con combinación de letras y números",
        "a10": "Las contraseñas no coinciden",
    },
    "withdrawal": {
        "a1": "Retiro",
        "a2": "Fondos disponibles",
        "a3": "Tarjeta bancaria",
        "a4": "Por favor seleccione su tarjeta bancaria",
        "a5": "Por favor ingrese el monto de retiro",
        "a6": "Enviar",
        "a7": "Por favor seleccione una tarjeta bancaria",
        "a8": "Ir a vincular",
        "a9": "Confirmar",
        // newText
        "a10": "Monto recibido",
        "a11": "Comisión",
        "a12": "Aviso de seguridad",
        "a13": "Confirmar",
        "a14": "Primero configure la contraseña de transacción",
        "a15": "Solicitud enviada. Debido a congestión bancaria, el monto se acreditará dentro de 24 horas.",
        "a16": "Seleccione una tarjeta bancaria",
        "a17": "Ingrese el monto a retirar",
        "a18": "Monto mínimo de retiro",
        // 
        "c1": "Enviado con éxito",
    },
    // newText
    "notifyPopupOtc": {
        "a1": "Notificación de suscripción mayorista",
        "a2": "Tiene varios productos de descuento mayorista pendientes de suscribirse",
        "a3": "Tiene un producto de descuento mayorista pendiente de suscribirse",
        "a4": "Nombre de la acción:",
        "a5": "Precio de suscripción:",
        "a6": "Precio de mercado:",
        "a7": "Moneda:",
        "a8": "Fecha límite:",
        "a10": "Tipo de acción:",
        "a11": "Precio de compra:",
        "a12": "Cantidad:",
        "a13": "Código bursátil:",
        "a14": "Número de orden:",
        "a15": "Hora de pago:",
        "a16": "Nombre de la empresa:",
        "a17": "Tipo de acción:",
        "a18": "Monto:",
        "a19": "Número de orden:",
        "a20": "Estado de revisión:",
        "a21": "Nota del usuario:",
        // new1206,
        "a9": "Nombre de la acción:",
        "d1": "Tiene varias órdenes al por mayor asignadas con éxito",
        "d2": "Tiene una orden al por mayor asignada con éxito",
        "d3": "Notificación de orden al por mayor",
        "d4": "Tiene varias órdenes al por mayor rechazadas",
        "d5": "Tiene una orden al por mayor rechazada",
        "d6": "Notificación de rechazo de orden al por mayor",
        "d7": "Rechazar"
    },
    "tyjPopup": {
        "a1": "Bono de prueba",
        "a2": "Tiempo restante para reclamar",
        "a3": "Bono de prueba",
        "a4": "Confirmar",
        // newText
        "a5": "Felicidades, su verificación fue aprobada",
        "a6": "Obtuvo",
        "a7": "Bono de prueba",
        "a8": "Cuenta regresiva del evento",
        "a9": "Invertir ahora",
    },
    "aiTransactionDetails": {
        "a1": "Detalles de la transacción",
        "a2": "Fecha",
        "a3": "Ganancia del día",
        "a4": "Detalles de acciones en posesión",
        "a5": "Precio de compra",
        "a6": "Precio de venta",
        "a7": "Cantidad de acciones",
        "a8": "Ganancia del día",
        // 
        "c1": "Operación inteligente en curso...",
    },
    "aiTransactionRecords": {
        "a1": "Registros de trading con IA",
        "a2": "En transacción",
        "a3": "Detalles de transacción",
        "a4": "Ciclo de trading",
        "a5": "Ganancia estimada",
        "a6": "Hora de vencimiento",
        "a7": "Hora de suscripción",
        "a8": "Ver detalles",
        "a9": "días",
        // new
        "c1": "Pendiente de confirmación",
        "c2": "En transacción",
        "c3": "Posición cerrada",
        "c4": "Tarea fallida",
    },
    "fqa": {
        "a1": "Preguntas frecuentes",
        "a2": "Matrix fue invitada por el gobierno argentino. Opera con base en NASDAQ, el segundo mercado más grande del mundo, bajo estricta supervisión de la SEC y FINRA, garantizando alta autoridad y credibilidad.",
        "a3": "Actualmente estamos en etapa de promoción inicial. No se cobra comisión por transacciones. Los retiros tienen una tasa del 0.3%. El tipo de cambio sigue el valor oficial entre peso y dólar.",
        "a4": "No hay costo por depositar fondos. Los depósitos grandes requieren reporte previo. Todo está regulado por instituciones gubernamentales y bancarias.",
        "a5": "El mercado tiene fluctuaciones naturales, lo cual implica riesgos y ganancias potenciales. La plataforma ofrece herramientas como IA y descuento mayorista para mayor estabilidad.",
        "a6": "La plataforma opera con datos reales del mercado argentino y del mercado estadounidense en tiempo real.",
        "a7": "Todo está estrictamente supervisado por la SEC y FINRA. ¡Los retiros incluyen una comisión estándar!",
        "a8": "Los usuarios pueden vincular su información y tarjetas bancarias, y operar todas las funciones del APP. Si la orden no se ejecuta o suscribe, es un comportamiento del mercado. Puede contactar soporte o los entes reguladores.",
        "a9": "El cliente debe operar normalmente y entender los riesgos. Cada usuario requiere validación KYC para operar. No se permite usar identidades ajenas.",
        "a11": "1. ¿La plataforma es legal y regulada?",
        "a12": "2. ¿Cómo se calculan las comisiones, tasas y tipos de cambio?",
        "a13": "3. ¿Son seguros los depósitos/retiros?",
        "a14": "4. ¿Es alto el riesgo del mercado?",
        "a15": "5. ¿Los datos son precisos?",
        "a16": "6. ¿Las responsabilidades legales y fiscales son válidas?",
        "a17": "7. ¿Los fondos están seguros? ¿Cómo presentar reclamos?",
        "a18": "8. ¿Cómo deben usar nuestra plataforma los clientes?",
    },
    // newText
    "loan": {
        "a1": "Solicitar préstamo",
        "a2": "Número telefónico",
        "a3": "Ingrese su número telefónico",
        "a4": "Formato incorrecto",
        "a5": "Nombre",
        "a6": "Ingrese su nombre",
        "a7": "Correo electrónico",
        "a8": "Ingrese su correo",
        "a9": "Monto",
        "a10": "Ingrese el monto del préstamo",
        "a11": "No cumple los requisitos para solicitar un préstamo. Contacte soporte para más información.",
    },
    "loanRecords": {
        "a1": "Historial de préstamos",
        "a2": "Solicitante",
        "a3": "Pendiente de revisión",
        "a4": "Aprobado",
        "a5": "Rechazado"
    },
    "withdrawalu": {
        "a1": "Dirección de retiro",
        "a2": "Monto recibido",
        "a3": "Comisión",
        "a4": "Aviso de vinculación",
        "a5": "Confirmar",
        "a6": "Vincule primero una dirección TRC",
        "a7": "Aviso de seguridad",
        "a8": "Configure primero la contraseña de transacción",
        "a9": "La dirección de retiro no puede estar vacía",
        "a10": "Ingrese el monto a retirar",
        "a11": "Monto mínimo de retiro",
        "a12": "Vincule primero una dirección ERC",
    },
    "about": {
        "a1": "Somos una firma de inversión de riesgo temprano, invirtiendo desde etapa de idea hasta rondas Serie A. Nuestro equipo está compuesto por exfundadores y constructores, con experiencia colaborando con Apple, FedEx, Oculus, Canva y más.",
        "a2": "Invertimos con convicción, apoyando fundadores con fuerte dominio técnico y visión clara del futuro.",
        "a3": "Equipo",
        "a4": "Somos un equipo unido de exfundadores e innovadores. Seleccionamos cuidadosamente los proyectos y dedicamos tiempo a ellos.",
        "a5": "Construimos a largo plazo, participando desde etapas tempranas.",
        "a6": "Inversiones",
        "a7": "Ilya Sukhan",
        "a8": "IA, infraestructura",
        "a9": "August Health, Chameleon, Fivetran, Flock Safety, Mashgin, Parabola, Sieve",
        "a10": "Dana Stalder",
        "a11": "Fintech, B2B",
        "a12": "ApartmentList, Baselane, EarnIn, Flexible Finance, Mudflap, Side, Steadily, Zest AI",
        "a13": "Antonio Rodriguez",
        "a14": "IA, tecnología avanzada",
        "a15": "August Health, Chameleon, Fivetran, Flock Safety, Mashgin, Parabola, Sieve",
        "a16": "Kojo Osei",
        "a17": "IA, infraestructura",
        "a18": "Hookdeck, Ampersand, LM Studio",
        "a19": "Proyectos",
        "a20": "Desafiantes, disruptores, innovadores. Nuestros proyectos están liderados por fundadores con profundo conocimiento técnico y visión única del futuro.",
        "a21": "Contáctenos — nunca es demasiado temprano",
        "a22": "San Francisco",
        "a23": "535 Mission St, Suite 2600, San Francisco, CA 94105. Tel: 650-798-1600",
        "a24": "Boston",
        "a25": "101 Main St, 17th Floor, Cambridge, MA 02142. Tel: 617-494-1223",
    },
    "AiTrialBonus": {
        "a3": "Reclamar bono de prueba",
        "a4": "Comenzar inversión IA",
        "a5": "Generar ganancias",
        "a6": "Estrategia del bono",
        "a7": "Ciclo inteligente de inversión",
        "a8": "Rentabilidad estimada",
        "a9": "Bono de prueba",
        "a10": "Enviar",
        "a11": "Mis ganancias",
        "a12": "Ganancia total actual",
        "a13": "Ganancia diaria",
        "a14": "Comprar",
        "a15": "Vender",
        "a16": "Cantidad en posesión",
        "a17": "Ganancia",
        "a18": "Esperando ganancias",
        "a19": "Aviso del evento",
        "a20": "Volver",
        "a21": "¡El evento ha finalizado!",
        "a1": "Solicitar fondos de prueba",
        "a2": "El análisis de algoritmos de IA y el control profesional de riesgos garantizan que cada inversión sea transparente, segura y controlable, protegiendo así sus activos",
        "b1": "Utilice la IA para generar riqueza en el futuro",
        "b2": "cielo"
    },
    "notifyPopupKyc": {
        "a1": "Registro exitoso, por favor complete la verificación KYC.",
        "a2": "Ir a verificar",
    },
    "store": {
        "a1": "Aviso de verificación",
        "a2": "Verificar ahora",
        "a3": "Cancelar",
        "a4": "Las transacciones requieren verificación de identidad. ¿Desea continuar?",
        "a5": "Ver verificación",
        "a6": "La verificación está en revisión. ¡No puede operar por el momento!"
    },
    // 1209
    "newRouter": {
        "a1": "Inicia sesión primero",
        "a2": "Iniciando sesión...",
        "a3": "Registrándose..."
    },
    "utils": {
        "a1": "{value}día {value2}hora {value3}minuto {value4}segundo"
    },
    "oneStocks": {
        "a1": "Máximo",
        "a2": "Mínimo",
        "a3": "Precio promedio",
        "a4": "Volumen de negociación",
        "a5": "Apertura anterior",
        "a6": "Cierre anterior",
        "a7": "Volatilidad",
        "a8": "Descuento alto",
        "a9": "Ir al comercio",
        "a10": "Intradiario",
        "a11": "Diario",
        "a12": "Semanal",
        "a13": "Mensual",
        "a14": "Trimestral",
        "a15": "Anual"
    },
    "antiFraud": {
        "a1": "Zona Antifraude",
        "a2": "Identificación de Fraude",
        "a3": "Puede copiar el enlace oficial o la información de contacto en el SMS/mensaje para su verificación. No haga clic en enlaces no oficiales ni introduzca la contraseña de su cuenta.",
        "a4": "Enviar",
        "a5": "Anuncio Importante",
        "a6": "Canales de Denuncia de Fraude",
        "a7": "Estafas de Empresas Fantasma",
        "a8": "Estafas de 'Inflar y Vender' o 'Promocionar Precios Altos para Inversores Minoristas'",
        "a9": "Estafas de 'Ventas en Corto para Acumular Fondos'",
        "a10": "Estafas de Cuentas de Jubilación",
        "a11": "Estafas de Falsa Familiaridad",
        "a12": "Protegeremos estrictamente la seguridad de su información personal.",
        "a13": "Su confianza es muy importante para nosotros. Entendemos la importancia de su información personal. Adoptaremos estrictas medidas de seguridad de acuerdo con las leyes y regulaciones para proteger completamente la seguridad de su información personal. Puede obtener más información al respecto en la «Política de Privacidad» y las «Condiciones de Servicio",
        "a14": "Política de Privacidad",
        "a15": "Términos del Servicio", "a16": "El contenido de verificación no puede estar vacío",
        "a17": "¡Envío exitoso! Espere pacientemente a que el servicio de atención al cliente se ponga en contacto con usted",
        "a18": "Canales de denuncia de fraude",
        "a19": "FBI — Centro de Denuncias Criminales",
        "a20": "Centro Nacional de Denuncias de Fraude y Ciberdelincuencia del Reino Unido",
        "a21": "Agencia Nacional de Policía de Corea",
        "a22": "Agencia Nacional de Policía de Japón",
        "a23": "Unión Europea",
        "a24": "Detalles",
        "a25": "Cualquiera puede ser víctima de fraudes y estafas financieras. La mejor defensa es mantenerse informado, alerta y seguro. A continuación, encontrará información sobre las estafas de servicios financieros más comunes, junto con consejos clave para ayudarle a evitar ser la próxima víctima.",
        "a26": "Estafa de empresa fantasma",
        "a27": "Los estafadores pueden hacerse pasar por una empresa legítima para engañarle y que transfiera dinero a su cuenta. En algunos casos, pueden hacerse pasar por un representante o una empresa de servicios financieros de buena reputación, como Interactive Brokers. El objetivo de una estafa de empresa fantasma es engañarle para que transfiera dinero a una cuenta que parece legítima, pero que en realidad pertenece a un estafador",
        "a28": "Estafas de \"bombeo y venta\" o \"bombeo y venta\"",
        "a29": "En estas estafas, los estafadores primero invierten en una acción y luego difunden información falsa o engañosa para crear un frenesí de compras, inflando artificialmente el precio de la acción. Después, venden sus propias acciones al alto precio y dejan de promocionarlas. A medida que el precio baja, otros inversores sufren pérdidas\".Este asesoramiento de inversión de primera mano, proporcionado por expertos, se le ofrece en función de su estatus privilegiado o especial",
        "a30": "Estafas de ventas en corto y acumulación",
        "a31": "Esto es lo opuesto a la estafa de \"bombear y vender\".En esta estafa, los estafadores difunden información falsa, haciendo creer a los inversores que una acción relativamente ilíquida se desplomará y debería venderse.Cuando los inversores ven esta información y venden la acción, provocando una fuerte caída del precio, los estafadores entran al mercado y compran acciones a bajo precio",
        "a32": "Estafas con cuentas de jubilación",
        "a33": "Para retirar fondos de una cuenta de jubilación, el beneficiario debe cumplir con un requisito de edad mínima. Generalmente, el retiro anticipado de los fondos de jubilación suele conllevar sanciones. En esta estafa, los estafadores afirman poder ayudar a las personas a retirar sus fondos de jubilación anticipadamente sin pagar sanciones a través de lagunas fiscales, y luego utilizan complejas estrategias para erosionar los activos de la cuenta de jubilación mediante comisiones, inversiones, etc.",
        "a34": "Estafa de Privilegios Abusivos",
        "a35": "Los estafadores que cometen estafas de privilegios abusivos suelen ser (o fingen ser) miembros de su grupo objetivo. Comprenden que las personas tienden a confiar más en quienes tienen antecedentes similares, por lo que utilizan la edad, la religión, la raza, el género o la identidad profesional para ganarse la confianza de la víctima. Las estafas de privilegios abusivos casi siempre implican inversiones falsas o inversiones en las que el estafador oculta información importante (como el riesgo de pérdida, el historial de inversiones o los antecedentes del iniciador del esquema)",
        "a36": "Muchas estafas dirigidas a conocidos son esquemas Ponzi o piramidales. Los fondos proporcionados por nuevos inversores a los iniciadores del esquema se utilizan para pagar a los primeros inversores, creando la ilusión de una inversión exitosa. Finalmente, cuando los fondos de los nuevos inversores se agotan y los inversores existentes exigen ganancias, la estafa fracasa y los inversores descubren que la mayor parte o la totalidad de su dinero ha desaparecido"
    },
    "Regulatorynfo": {
        "a0": "Información reglamentaria",
        "a1": "Registrada ante la Comisión de Bolsa y Valores de EE. UU. (SEC). Miembro de la Autoridad Reguladora de la Industria Financiera (FINRA). Norma de Protección al Cliente (Regla 15c3-3 de la SEC): El efectivo y los valores de los clientes se mantienen separados de los activos propios de la empresa y en cuentas protegidas. Cumplimiento de FATCA/W-8BEN: Los clientes no estadounidenses están sujetos a las normas de declaración y retención de impuestos del IRS.",
        "a2": "Miembro de FINRA y SIPC. Valores protegidos por SIPC hasta $500,000 (incluye $250,000 en efectivo). No asegurado por la FDIC. Sin garantía bancaria. Puede perder valor. © 2026 Matrix Quant Inc. Todos los derechos reservados.",
    },
    "riskDisclosure": {
        "a0": "Divulgación de riesgos",
        "a1": "Todas las inversiones conllevan riesgos y no son adecuadas para todos los inversores.",
        "a2": "Podría perder parte o la totalidad del capital invertido.",
        "a3": "Los resultados pasados ​​no son indicativos de resultados futuros.",
        "a4": "La volatilidad del mercado, las condiciones económicas y los acontecimientos geopolíticos pueden tener un impacto adverso en los precios de los activos.",
        "a5": "Riesgos de las operaciones con margen",
        "a6": "Operar con margen implica riesgos significativos.",
        "a7": "La cantidad que pierdas podría superar el saldo de tu cuenta.",
        "a8": "Para cumplir con los requisitos de margen, la empresa podrá liquidar sus valores sin previo aviso.",
        "a9": "Usted no tiene derecho a solicitar una prórroga del plazo para la notificación de la llamada de margen.",
        "a10": "Riesgos de la negociación de opciones",
        "a11": "La negociación de opciones conlleva riesgos y no es adecuada para todos los inversores.",
        "a12": "Lea atentamente el documento \"Características y riesgos de las opciones estandarizadas\" antes de operar.",
        "a13": "Podrías perder todas las primas que has pagado.",
        "a14": "La venta de opciones puede ocasionar pérdidas ilimitadas.",
        "a15": "Riesgos de las operaciones intradía",
        "a16": "Las operaciones intradía pueden ocasionar pérdidas significativas.",
        "a17": "Los operadores intradía deben mantener un patrimonio neto de al menos 25.000 dólares.",
        "a18": "Las transacciones rápidas pueden generar altos costos de transacción.",
        "a19": "Debido a fallos del sistema, problemas de conectividad o volatilidad del mercado, la ejecución de las operaciones puede sufrir retrasos o ser imposible.",
        "a20": "En mercados que fluctúan rápidamente, los precios pueden caer bruscamente.",
        "a21": "Aviso reglamentario",
        "a22": "La negociación de valores fue proporcionada por MatrixQuant Inc., un corredor de bolsa registrado ante la Comisión de Bolsa y Valores de los Estados Unidos (SEC) y miembro de FINRA y SIPC."
    }
};